/**
 * Chiamate API (baseUrl = origin dello script + /api).
 */
export function createApi(baseUrl) {
  async function get(path, params = {}) {
    const qs = new URLSearchParams(params).toString()
    const url = qs ? `${baseUrl}${path}?${qs}` : `${baseUrl}${path}`
    const res = await fetch(url, { credentials: 'omit' })
    if (!res.ok) throw new Error(`API ${res.status}: ${res.statusText}`)
    return res.json()
  }

  async function postForm(path, data) {
    const form = new FormData()
    for (const [k, v] of Object.entries(data)) {
      if (v !== undefined && v !== null && v !== '') form.append(k, v)
    }
    const res = await fetch(`${baseUrl}${path}`, {
      method: 'POST',
      body: form,
      credentials: 'omit',
    })
    if (!res.ok) throw new Error(`API ${res.status}: ${res.statusText}`)
    return res.json()
  }

  return {
    gommistaById(id) {
      return get('/gommista_by_id/', { id })
    },
    slotsByDate(gommistaCodGest, start, stop) {
      return get('/slots_gommista_by_date/', {
        gommista_cod_gest: gommistaCodGest,
        start,
        stop,
      })
    },
    inviaPrenotazione(data) {
      return postForm('/invia_prenotazione_gommista/', data).then((result) => {
        const esito = Number(result?.esito)
        if (esito < 0 || esito === 0 || result?.ok === false) {
          throw new Error(result?.messaggio || 'Errore in prenotazione')
        }
        return result
      })
    },
  }
}

/**
 * Normalizza slots dalla API (dict { "YYYY-MM-DD": { orario: ["09:00", ...] } }) in array.
 */
export function normalizeSlots(slots) {
  if (Array.isArray(slots)) return slots
  if (!slots || typeof slots !== 'object') return []
  const out = []
  for (const [data, val] of Object.entries(slots)) {
    const orari = val?.orario
    const arr = Array.isArray(orari) ? orari : (orari ? [orari] : [])
    for (const ora of arr) out.push({ data, ora })
  }
  return out
}
